(() => {
  const stateKey = 'dacWishlistScroll';
  const isBack = performance.getEntriesByType?.('navigation')?.[0]?.type === 'back_forward';
  let pending = isBack ? history.state?.[stateKey] : null;
  let departure, revision = 0;
  const grid = () => document.querySelector('.wishlist-products');
  const valid = value => value && value.url === location.href && Number.isFinite(value.y) && value.y >= 0 &&
    value.width === innerWidth && value.scale === 1 && (window.visualViewport?.scale ?? 1) === 1 &&
    typeof value.listId === 'string' && Number.isInteger(value.view) &&
    Number.isFinite(value.time) && Date.now() - value.time >= 0 && Date.now() - value.time < 1800000;

  function view() {
    const controls = [...document.querySelectorAll('.wishlist-products-view .collection-filters input, .wishlist-products-view #wishlist-sort')];
    const values = controls.map(input => [input.name, input.type, input.value, input.checked]);
    let hash = 2166136261;
    for (const char of JSON.stringify(values)) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
    return hash >>> 0;
  }

  function clearCheckpoint() {
    const state = history.state;
    if (!state || typeof state !== 'object' || Array.isArray(state) || !(stateKey in state)) return;
    const next = { ...state };
    delete next[stateKey];
    try { history.replaceState(next, ''); } catch (_) {}
  }

  function cancel() { pending = null; revision++; }

  function restore(cached = false) {
    if (!pending) return;
    if (!valid(pending)) { cancel(); return; }
    const current = grid();
    if (!current?.dataset.dacWishlistList) return;
    if (current.dataset.dacWishlistList !== pending.listId || view() !== pending.view) { cancel(); return; }
    if (document.documentElement.scrollHeight - innerHeight < pending.y) return;
    const saved = pending, expected = revision;
    const apply = () => {
      if (expected !== revision || pending !== saved || !valid(saved) ||
        grid()?.dataset.dacWishlistList !== saved.listId || view() !== saved.view ||
        document.documentElement.scrollHeight - innerHeight < saved.y) return;
      if (!cached || scrollY === 0) scrollTo({ top: saved.y, behavior: 'instant' });
      cancel();
    };
    if (cached) apply();
    else requestAnimationFrame(apply);
  }

  window.DACWishlistHistory = {
    initialCount(listId, total) {
      if (!valid(pending) || pending.listId !== String(listId) || pending.view !== view()) return 24;
      return Number.isInteger(pending.count) && pending.count > 0 ? Math.min(pending.count, total) : total;
    }
  };

  addEventListener('pagehide', () => {
    const current = grid();
    const listId = current?.dataset.dacWishlistList;
    const saved = listId ? { url: location.href, listId, y: scrollY, width: innerWidth,
      scale: window.visualViewport?.scale ?? 1, time: Date.now(), view: view(), count: Number(current.dataset.dacWishlistVisibleCount) || 0 } : null;
    cancel();
    departure = saved;
    if (!valid(saved)) { clearCheckpoint(); return; }
    if (history.state !== null &&
      (typeof history.state !== 'object' || Array.isArray(history.state))) return;
    try { history.replaceState({ ...history.state, listId, [stateKey]: saved }, ''); } catch (_) {}
  });

  addEventListener('pageshow', event => {
    if (event.persisted) {
      cancel();
      if (scrollY === 0 && valid(departure) && departure.y > 0) {
        pending = departure;
        restore(true);
      }
      return;
    }
    restore();
  }, { capture: true });
  document.addEventListener('dac:wishlist-view-ready', () => restore());
  document.addEventListener('dac:wishlistFilter', cancel, true);
  document.addEventListener('change', cancel, true);
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => addEventListener(type, cancel, { passive: true }));
  addEventListener('popstate', () => { if (pending && pending.url !== location.href) cancel(); });
})();
